import { LandingNavbar } from '@/components/landing/LandingNavbar'
import { Hero, AnswerChooser } from '@/components/landing/Hero'
import { StoreCheck } from '@/components/landing/StoreCheck'
import { Evidence } from '@/components/landing/Evidence'
import { PageAnatomy } from '@/components/landing/PageAnatomy'
import { Commitments } from '@/components/landing/Commitments'
import { LandingFAQ } from '@/components/landing/LandingFAQ'
import { CTASection } from '@/components/landing/CTASection'
import { Footer } from '@/components/landing/Footer'
import { useTranslation } from 'react-i18next'
import { usePublicHrefs } from '@/components/landing/usePublicHrefs'

/** Public merchant introduction, followed by Store Check and complete guidance. */
export function Landing() {
  const { t } = useTranslation()
  const { guide: answersHref } = usePublicHrefs()

  return (
    <div className="lp-root relative min-h-screen">
      <a
        href="#main-content"
        className="sr-only z-[100] rounded-md px-4 py-2 shadow focus:not-sr-only focus:fixed focus:left-4 focus:top-4"
        style={{
          backgroundColor: 'var(--lp-raised)',
          color: 'var(--lp-ink)',
        }}
      >
        {t('landing:nav.skip_to_content')}
      </a>

      <LandingNavbar />

      <main id="main-content">
        <Hero answersHref={answersHref} />
        <StoreCheck />
        <AnswerChooser answersHref={answersHref} />
        <PageAnatomy />
        <Evidence />
        <Commitments />
        <LandingFAQ />
        <CTASection answersHref={answersHref} />
      </main>

      <Footer />
    </div>
  )
}

export default Landing
